// Servicios para casos médicos

// import { json } from "react-router-dom";
import { BASE_URL, CaseStatus } from "../constants";
import { getAuthHeader } from "../utils";
// import { addPerson, getPeopleMatchingCI } from "./people";

/**
 * @typedef MedicalCaseRequirement
 * @property {number} id
 * @property {number} requirement
 * @property {number} medical_case
 * @property {string} amount
 * @property {string} requirement_name
 * @property {string} type_requirement
 * @property {boolean} is_done
 */

/**
 * @typedef MedicalCaseInvoice
 * @property {number} id
 * @property {string} file
 * @property {number} medical_case
 * @property {string} file_name
 */

/**
 * @typedef MedicalCaseFile
 * @property {string} file
 * @property {number} medical_case
 * @property {string} file_name
 * @property {string} type_requirement Tipo de archivo
 */

/**
 * @typedef ChildMedicalCase
 * @property {number} id
 * @property {string} medical_center_name
 * @property {string} status
 * @property {MedicalCaseRequirement[]} requirements
 * @property {MedicalCaseInvoice[]} invoice
 */

/**
 * @typedef MedicalCase
 * @property {number} id
 * @property {number} patient
 * @property {number} holder
 * @property {number[]} diagnosis
 * @property {string} diagnosis_name
 * @property {import("./people").Person} holder_
 * @property {import("./people").Person} patient_
 * @property {number?} patient_age
 * @property {number} medical_center
 * @property {string} medical_center_name
 * @property {number?} parent_medical_center
 * @property {string?} parent_medical_center_name
 * @property {string} insurance_name
 * @property {string} status
 * @property {string} amount
 * @property {number} subsidiary
 * @property {string} subsidiary_name
 * @property {number} company_client_id
 * @property {string} company_client_name
 * @property {string} created_at Creation timestamp in UTC string
 * @property {MedicalCaseRequirement[]} requirements
 * @property {MedicalCaseInvoice[]} invoice
 * @property {MedicalCaseFile[]} files
 * @property {string?} medical_center_currency
 * @property {string?} parent_case_currency
 * @property {ChildMedicalCase[]?} children
 * @property {string?} schedule_date
 * @property {string?} medical_order
 */

/**
 * Helper function to handle fetch requests
 * @param {string} url
 * @param {object} options
 * @returns {Promise<any>}
 */
async function fetchData(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...getAuthHeader(),
      ...options.headers,
    },
  });
  if (!response.ok) {
    throw new Error(JSON.stringify(await response.json()));
  }
  return response.json();
}

/**
 * Returns list of medical cases, filtered by medicalCenterId
 */
export async function getCases(page, pageSize = 50, filters) {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  queryParams.append("page_size", pageSize);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
  }

  return fetchData(
    `${BASE_URL}insurance/medical-case/?${queryParams.toString()}`
  );
}

/**
 * Returns list of medical cases, filtered by medicalCenterId
 */
export async function getAllCases({
  page,
  pageParam = 1,
  pageSize = 100,
  filters,
}) {
  console.log("PageParam", pageParam);
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  queryParams.append("page", pageParam);
  queryParams.append("page_size", pageSize);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
  }

  // if (allResults) {
  //   queryParams.delete("page");
  //   queryParams.delete("page_size");
  //   queryParams.append("page", 1);
  //   queryParams.append("page_size", 100);
  //   const data = await fetchData(
  //     `${BASE_URL}insurance/medical-case/?${queryParams.toString()}`
  //   );

  //   let results = data.results;

  //   // Get all data from pagination

  //   let nextUrl = data.next;
  //   while (nextUrl && allResults) {
  //     try {
  //       const nextResponse = await fetchData(nextUrl);
  //       // const nextData = await nextResponse.json();
  //       results = results.concat(nextResponse.results);

  //       nextUrl = nextResponse.next;
  //     } catch (error) {
  //       console.log(error);
  //       break;
  //     }
  //   }

  //   return { results: results, count: results.length };
  // }

  return fetchData(
    `${BASE_URL}insurance/medical-case/?${queryParams.toString()}`
  );
}

export async function getExportCases({
  page,
  pageParam = 1,
  pageSize = 100,
  filters,
}) {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  queryParams.append("page", pageParam);
  queryParams.append("page_size", pageSize);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
  }

  return fetchData(
    `${BASE_URL}insurance/export-medical-cases/?${queryParams.toString()}`
  );
}

export async function getCasesCount() {
  return fetchData(`${BASE_URL}insurance/medical-case/counts/`);
}

/**
 * Subscribe to medical cases updates
 * @param {function(MedicalCase[]): void} callback
 * @returns {() => void} Unsubscribe function
 */
export async function getCasesSubscribe(
  page,
  pageSize = 50,
  filters,
  allResults = false
) {
  console.log("page", page, "pagesize", pageSize, filters);
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  queryParams.append("page_size", pageSize);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
  }
  if (allResults) {
    queryParams.delete("page");
    queryParams.delete("page_size");
    queryParams.append("page", 1);
    queryParams.append("page_size", 100);
    const data = await fetchData(
      `${BASE_URL}insurance/medical-case-subscribe/?${queryParams.toString()}`
    );

    let results = data.results;

    // Get all data from pagination

    let nextUrl = data.next;
    while (nextUrl) {
      // If nextUrl begins with http, replace with https
      if (nextUrl.startsWith("http://")) {
        nextUrl = nextUrl.replace("http://", "https://");
      }
      try {
        const nextResponse = await fetchData(nextUrl);
        // const nextData = await nextResponse.json();
        results = results.concat(nextResponse.results);

        nextUrl = nextResponse.next;
      } catch (error) {
        console.log(error);
        break;
      }
    }

    return { results: results, count: results.length };
  }

  return fetchData(
    `${BASE_URL}insurance/medical-case-subscribe/?${queryParams.toString()}`
  );
}

/**
 * Get case detail from ID
 * @param {number} caseId
 */
export async function getCaseById(caseId) {
  const response = await fetch(`${BASE_URL}insurance/medical-case/${caseId}/`, {
    headers: {
      ...getAuthHeader(),
    },
  });
  if (!response.ok) {
    throw new Error(JSON.stringify(response));
  }
  /**@type {MedicalCase} */
  const data = await response.json();
  return data;
}

/**
 * Update status of medical case
 * @param {object} params
 * @param {number} params.caseId
 * @param {{ status: string, update_observation: string?, schedule_date: Date? }} params.data
 */
export async function updateCaseStatus({ caseId, data }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case/${caseId}/`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      const json = await response.json();
      throw new Error(JSON.stringify(json));
    }
    return { type: "success", message: "Caso actualizado correctamente." };
  } catch (error) {
    console.error("Error updating case: ", error);
    return { type: "error", message: "Error actualizando el estado del caso" };
  }
}

/**
 * Update the status of multiple medical cases
 * @param {object} params
 * @param {number[]} params.caseIds
 * @param {string} params.status
 */
export async function updateMultipleCasesStatus({ caseIds, status }) {
  try {
    await Promise.allSettled(
      caseIds.map((caseId) => updateCaseStatus({ caseId, data: { status } }))
    );
    return {
      type: "success",
      message: "Estados de los casos actualizados correctamente.",
    };
  } catch (error) {
    console.error("Error updating cases: ", error);
    return {
      type: "error",
      message: "Error actualizando los estados de los casos",
    };
  }
}

/**
 *
 * @param {object} params
 * @param {number} params.caseId
 * @param {{ requirement: number, is_done: boolean}[]} params.requirements
 */
export async function addRequirements({ caseId, requirements }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case/${caseId}/`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({ requirements }),
      }
    );
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    return {
      type: "success",
      message: "Requerimientos actualizados.",
    };
  } catch (error) {
    console.error("Error updating case: ", error);
    return {
      type: "error",
      message: "Error agregando requerimientos",
    };
  }
}

/**
 *
 * @param {object} params
 * @param {number} params.caseId
 * @param {{ id: number, requirement: number, is_done: boolean }[]} params.doneRequirements
 */
export async function updateCaseRequirementsDone({ caseId, doneRequirements }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case/${caseId}/`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({
          requirements: doneRequirements,
          status: CaseStatus.ATENDIDO,
        }),
      }
    );
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    return {
      type: "success",
      message: "Requerimientos marcados como completados.",
    };
  } catch (error) {
    console.error("Error updating case: ", error);
    return {
      type: "error",
      message: "Error marcando requerimientos como completados",
    };
  }
}

/**
 * Returns date in format Y-m-d
 * @param {string | number} day
 * @param {string | number} month
 * @param {string | number} year
 */
// function formatBirthDate(day, month, year) {
//   if (day < 10) {
//     day = "0" + day;
//   }
//   if (month < 0) {
//     month = "0" + month;
//   }
//   return `${year}-${month}-${day}`;
// }

/**
 * CREAR CASO - NUEVO FORMATO
 * {
    "patient": 1,
    "holder": 1,
    "diagnosis": [1],
    "medical_center": 1,
    "status": "pendiente",
    "subsidiary":1,
    "requirements": [{
        "requirement": 19
    }]
  }
 */

/**
 * Add new medical case
 * @param {object} data
 * @param {object} data.patient
 * @param {object} data.holder
 * @param {object[]} data.requirements
 * @param {boolean} data.prioritized
 * @param {File?} data.medicalOrder
 */
export async function addCase({
  patient,
  holder,
  requirements,
  duplicate = false,
  serviceNumber = null,
  prioritized = false,
  state = null,
  address,
  city,
  medicalOrder = null,
}) {
  try {
    // Validations @todo
    if (
      !requirements ||
      !Array.isArray(requirements) ||
      requirements.length === 0
    ) {
      throw new Error("Debe seleccionar al menos un requerimiento.");
    }
    const holderCi = holder.ciType + holder.ci;
    const phone = holder.phoneCode + holder.phoneNumber;
    const optionalPhone = holder.optionalPhoneCode + holder.optionalPhoneNumber;
    const holderData = {
      ci: holderCi,
      name: holder.name,
      sex: holder.sex,
      birthdate: holder.birthDate.split("/").reverse().join("-"),
      phone: phone,
      subsidiary: patient.subsidiary,
      is_holder: true,
      holder: null,
      condition: holder.condition,
      optional_phone: optionalPhone,
      landline_phone: holder.landlinePhoneNumber,
    };

    // Create holder if necessary
    // let holderId = null;
    // if (holder.shouldCreateHolder) {
    //   const holderData = {
    //     ci: holder.ciType + holder.ci,
    //     name: holder.name,
    //     sex: holder.sex,
    //     birthdate: holder.birthDate.split("/").reverse().join("-"),
    //     phone: holder.phoneCode + holder.phoneNumber,
    //     subsidiary: patient.subsidiary,
    //     is_holder: true,
    //     holder: null,
    //     condition: holder.condition,
    //   }
    //   const holderResponse = await addPerson(holderData);
    //   if (holderResponse.type === "error") {
    //     return holderResponse;
    //   }
    //   holderId = holderResponse.personId;
    // }
    // if (holderId === null) {
    //   const holderMatch = await getPeopleMatchingCI(holder.ciType + holder.ci);
    //   holderId = holderMatch[0].id;
    // }

    // Create patient if necessary
    // let patientId = null;
    let patientData = null;
    if (!patient.isHolder) {
      let ciPatient = patient.ciType + patient.ci;
      if (patient.ciType === "M") {
        patient.isMinor = true;
        ciPatient = holder.ciType + holder.ci;
      }
      patientData = {
        id: null,
        ci: ciPatient,
        name: patient.name,
        sex: patient.sex,
        birthdate: patient.birthDate.split("/").reverse().join("-"),
        phone: phone,
        subsidiary: patient.subsidiary,
        is_holder: false,
        holder: null,
        holder__ci: holderCi,
        minor_id: patient.minorId,
        is_minor: patient.isMinor,
        optional_phone: optionalPhone,
      };
    }

    // console.log("patientData", patientData);

    // if (patient.shouldCreatePatient) {
    //   const patientData = {
    //     ci: patient.ciType + patient.ci,
    //     name: patient.name,
    //     sex: patient.sex,
    //     birthdate: patient.birthDate.split("/").reverse().join("-"),
    //     phone: patient.phoneCode + patient.phoneNumber,
    //     subsidiary: patient.subsidiary,
    //     is_holder: false,
    //     holder: holderId,
    //   };
    // const patientResponse = await addPerson(patientData);
    // if (patientResponse.type === "error") {
    //   return patientResponse;
    // }
    // patientId = patientResponse.personId;
    // }

    // Find patient ID through CI
    // if (!patient.isHolder && !patientId) {
    //   const patientMatch = await getPeopleMatchingCI(patient.ciType + patient.ci);
    //   patientId = patientMatch[0].id;
    // }

    // Add case
    const caseData = {
      // patient: Number(patientId),
      service_number: serviceNumber,
      patient: patientData,
      holder: holderData,
      diagnosis: patient.diagnosis,
      medical_center: Number(requirements[0].medicalCenter),
      status: "pendiente",
      subsidiary: Number(patient.subsidiary),
      requirements: requirements.map((req) => ({
        requirement: Number(req.requirement),
      })),
      duplicate,
      state,
      address,
      city,
    };
    const response = await fetch(BASE_URL + "insurance/medical-case/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(caseData),
    });
    if (response.status === 400) {
      const json = await response.json();

      return { type: "error", message: json.message, code: json?.code };
    }
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const createdCase = await response.json();
    if (medicalOrder) {
      await addMedicalOrderToCase({ caseId: createdCase.id, medicalOrder });
    }
    return {
      type: "success",
      message: "Caso agregado correctamente.",
      data: createdCase,
    };
  } catch (error) {
    console.error("Error adding case: ", error.message);
    return { type: "error", message: error.message };
  }
}

/**
 * Add medical order to case
 * @author gabrielm
 * @param {object} params
 * @param {number} params.caseId
 * @param {File} params.medicalOrder
 */
export async function addMedicalOrderToCase({ caseId, medicalOrder }) {
  try {
    const formData = new FormData();
    formData.append("medical_order", medicalOrder);
    const response = await fetch(
      `${BASE_URL}insurance/medical-case/${caseId}/`,
      {
        method: "PATCH",
        headers: {
          ...getAuthHeader(),
        },
        body: formData,
      }
    );
    if (!response.ok) {
      const json = await response.json();
      throw new Error(JSON.stringify(json));
    }
    return {
      type: "success",
      message: "Orden médica agregada correctamente.",
    };
  } catch (error) {
    console.error("Error adding medical order: ", error);
    return { type: "error", message: "Error agregando la orden médica" };
  }
}

/**
 * Delete invoice file from medical case
 * @param {object} params
 * @param {number} params.invoiceId
 */
export async function deleteMedicalCaseInvoice({ invoiceId }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case-invoice/${invoiceId}/`,
      {
        method: "DELETE",
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    if (!response.ok) {
      const json = await response.json();
      // console.log(json);
      throw new Error(JSON.stringify(json));
    }
    return {
      type: "success",
      message: "Factura eliminada correctamente.",
      id: invoiceId,
    };
  } catch (error) {
    return { type: "error", message: "Error eliminando la factura" };
  }
}

/**
 * Delete a file from a medical case
 * @param {object} params
 * @param {number} params.fileId
 */
export async function deleteMedicalCaseFile({ fileId }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case-file/${fileId}/`,
      {
        method: "DELETE",
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    if (!response.ok) {
      const json = await response.json();
      throw new Error(JSON.stringify(json));
    }
    return {
      type: "success",
      message: "Archivo eliminado correctamente.",
      id: fileId,
    };
  } catch (error) {
    return { type: "error", message: "Error eliminando el archivo" };
  }
}

export async function medicalCaseToPending({ caseId }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case-to-pending/${caseId}/`,
      {
        method: "PATCH",
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    const json = await response.json();
    if (!response.ok) {
      // console.log(json);
      throw new Error(JSON.stringify(json));
    }

    return {
      type: "success",
      message: json.message,
      isOk: json.is_ok,
      id: caseId,
    };
  } catch (error) {
    console.error("cambiar a pendiente: ", error);
    return { type: "error", message: "Error " };
  }
}

/**
 * Create massive cases
 * @author gabrielm
 * @param {object[]} cases
 */
export async function createMassiveCases(cases) {
  try {
    const response = await fetch(BASE_URL + "insurance/medical-case/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(cases),
    });
    if (response.status === 400) {
      const json = await response.json();
      return { type: "error", message: json?.message, code: json?.code };
    }
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }

    return {
      type: "success",
      message: "Caso agregado correctamente",
      data: await response.json(),
    };
  } catch (error) {
    console.error("Error creando casos masivos: ", error);
    return { type: "error", message: "Error creando casos masivos" };
  }
}

/** Reassign a medical case from a sub-administrator to a medical center
 * @author gabrielm
 * @param {object} params
 * @param {number} params.caseId
 * @param {object[]} params.assigned
 */
export async function reassignMedicalCase({ caseId, assigned }) {
  try {
    const response = await fetch(`${BASE_URL}insurance/medical-case/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify({
        medical_case_id: caseId,
        assigned_centers: assigned,
      }),
    });
    const json = await response.json();
    if (!response.ok) {
      // console.log(json);
      throw new Error(JSON.stringify(json));
    }
    return {
      type: "success",
      message: json.message,
    };
  } catch (error) {
    console.error("Error reassigning case: ", error);
    return { type: "error", message: "Error asignando el caso" };
  }
}

/**
 * Crea un caso médico y lo reasigna
 * @author gabrielm
 * @param {object} caseData
 */
export async function createCaseAndReassign(caseData) {
  try {
    // Crear caso principal
    const createResponse = await addCase(caseData);
    if (createResponse.type === "error") {
      return createResponse;
    }

    const { data: createdCase } = createResponse;

    // Agrupar requerimientos por proveedor
    const groupedRequirements = {};
    if (caseData.requirements && Array.isArray(caseData.requirements)) {
      caseData.requirements.forEach((req) => {
        const subAdminId = req.subAdminMedicalCenter;
        if (!groupedRequirements[subAdminId]) {
          groupedRequirements[subAdminId] = [];
        }
        groupedRequirements[subAdminId].push(req);
      });
    }

    // Dar formato correcto
    const assigned = Object.entries(groupedRequirements).map(
      ([subAdminId, requirements]) => ({
        medical_center: subAdminId,
        requirements: requirements.map((req) => ({
          requirement: req.requirement,
        })),
      })
    );

    // Reasignar caso
    const reassignResponse = await reassignMedicalCase({
      caseId: createdCase.id,
      assigned,
    });
    if (reassignResponse.type === "error") {
      return reassignResponse;
    }

    return {
      type: "success",
      message: "Caso agregado correctamente.",
      data: {
        ...createResponse.data,
      },
    };
  } catch (error) {
    console.error("Error creating case and reassigning: ", error);
    return { type: "error", message: "Error creando el caso" };
  }
}

/**
 * Change medical center of a medical case to subscribe
 * @author gabrielm
 * @param {object} params
 * @param {number} params.caseId
 * @param {number} params.medicalCenterId
 */
export async function changeCaseMedicalCenter({ caseId, medicalCenterId }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case/${caseId}/`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({
          new_medical_center: medicalCenterId,
        }),
      }
    );
    const json = await response.json();
    if (!response.ok) {
      throw new Error(json.message);
    }
    return {
      type: "success",
      message: "Se ha cambiado el proveedor",
    };
  } catch (error) {
    console.error("Error reassigning case: ", error);
    return { type: "error", message: error.message };
  }
}

/**
 * Get medical case status history
 * @author gabrielm
 * @param {number} caseId
 */
export async function getMedicalCaseStatusHistory(caseId) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case-status-history/${caseId}/`,
      {
        method: "GET",
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting medical case status history: ", error);
    return [];
  }
}

/**
 * Add new medical case
 * @param {object} data
 * @param {object} data.patient
 * @param {object} data.holder
 * @param {boolean} data.prioritized
 */
export async function updateCase({
  caseId,
  patient = null,
  holder = null,
  serviceNumber = undefined,
  prioritized = false,
  state = undefined,
  address = undefined,
  diagnosis = undefined,
  requirements = undefined,
  status = undefined,
  medicalCenter = undefined,
}) {
  try {
    let holderData = undefined;
    if (holder) {
      const holderCi = holder.ciType + holder.ci;
      const phone = holder.phoneCode + holder.phoneNumber;
      const optionalPhone = holder.optionalPhoneCode + holder.optionalPhoneNumber;
      holderData = {
        ci: holderCi,
        name: holder.name,
        sex: holder.sex,
        birthdate: holder.birthDate.split("/").reverse().join("-"),
        phone: phone,
        subsidiary: patient.subsidiary,
        is_holder: true,
        holder: null,
        condition: holder.condition,
        optional_phone: optionalPhone,
        landline_phone: holder.landlinePhoneNumber,
      };
    }

    // Create patient if necessary
    let patientData = undefined;
    if (patient) {
      const holderCi = holder.ciType + holder.ci;
      const phone = holder.phoneCode + holder.phoneNumber;
      const optionalPhone =
        holder.optionalPhoneCode + holder.optionalPhoneNumber;
      if (!patient.isHolder) {
        let ciPatient = patient.ciType + patient.ci;
        if (patient.ciType === "M") {
          patient.isMinor = true;
          ciPatient = holder.ciType + holder.ci;
        }
        patientData = {
          id: null,
          ci: ciPatient,
          name: patient.name,
          sex: patient.sex,
          birthdate: patient.birthDate.split("/").reverse().join("-"),
          phone: phone,
          subsidiary: patient.subsidiary,
          is_holder: false,
          holder: null,
          holder__ci: holderCi,
          minor_id: patient.minorId,
          is_minor: patient.isMinor,
          optional_phone: optionalPhone,
        };
      }
    }

    // Add case
    const caseData = {
      service_number: serviceNumber,
      new_patient: patientData,
      new_holder: holderData,
      new_diagnosis: patient?.diagnosis,
      new_subsidiary: patient ? Number(patient.subsidiary) : undefined,
      prioritized,
      state,
      address,
      city: holder?.city,
      diagnosis,
      requirements,
      status,
      medical_center: medicalCenter ? Number(medicalCenter) : undefined,
    };
    const response = await fetch(
      BASE_URL + "insurance/medical-case/" + caseId + "/",
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify(caseData),
      }
    );
    if (response.status === 400) {
      const json = await response.json();

      return { type: "error", message: json.message, code: json?.code };
    }
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    return {
      type: "success",
      message: "Caso agregado correctamente.",
      data: await response.json(),
    };
  } catch (error) {
    console.error("Error adding case: ", error.message);
    return { type: "error", message: error.message };
  }
}

/**
 * Devuelve la lista de casos médicos que el centro debe marcar agendados o atendidos para continuar
 * @author gabrielm
 */
export async function getStaleMedicalCases(page, pageSize = 20, filters) {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    queryParams.append("page_size", pageSize);
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });
    }
    const response = await fetch(
      `${BASE_URL}insurance/stale-medical-cases/?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    /**@type {MedicalCase[]} */
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error getting stale medical cases: ", error);
    return [];
  }
}

/**
 * Generar siniestro de un caso médico ATENDIDO
 **/

export async function medicalCaseGenerateSiniestro({ caseId }) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/medical-case/${caseId}/generate_siniestro/`,
      {
        method: "PATCH",
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    const json = await response.json();
    if (!response.ok) {
      // console.log(json);
      throw new Error(JSON.stringify(json));
    }

    return {
      type: "success",
      message: json.message,
      isOk: json.is_ok,
      clave: json.clave,
      id: caseId,
    };
  } catch (error) {
    return {
      type: "error",
      message: error.message.message || "Error generando el siniestro",
    };
  }
}

/**
 * Get pending requests for insurance
 * @author gabrielm
 * @param {number} page
 * @param {number} pageSize
 * @param {object} filters
 */
export async function getPendingRequests(page, pageSize = 50, filters) {
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  queryParams.append("page_size", pageSize);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value) queryParams.append(key, value);
    });
  }

  return fetchData(
    `${BASE_URL}insurance/pending-requests/?${queryParams.toString()}`
  );
}

/**
 * Consulta si existe la orden externa para el caso
 * @param {number} caseId
 * @returns {Promise<any|null>}
 */
export async function getExternalOrder(caseId) {
  try {
    const response = await fetch(
      `${BASE_URL}insurance/get-external-order/?medical_case_id=${caseId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      }
    );
    if (!response.ok) {
      return null;
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error consultando orden externa:", error);
    return null;
  }
}
